<template>
	<!-- Pagination -->
	<div class="d-flex justify-content-between align-items-center">
		<!-- Items Statistic -->
		<div class="items-statistic">
			From
			{{ formatNumberLocale(pagination.from) }}
			to
			{{ formatNumberLocale(pagination.to) }}
			of
			{{ formatNumberLocale(pagination.total) }}
		</div>
		<!-- Pages navigation -->
		<div v-if="pagination.last_page > 1">
			<nav>
				<ul class="pagination" v-if="pagination.links && pagination.links.length > 0">
					<li
						:key="'pag-' + index"
						v-for="(link, index) in pagination.links"
						class="page-item"
						:class="link.active ? 'active' : ''"
					>
						<a role="button" :disabled="true" class="page-link" @click="setPage(link.url)">{{
							link.label | removeString
						}}</a>
					</li>
				</ul>
			</nav>
		</div>
	</div>
</template>

<script>
import { formatNumberLocale as formatNumberLocaleUtil } from '@/actions/helpers'
export default {
	name: 'LPDataTablePagination',
	props: ['pagination'],
	data() {
		return {}
	},
	created() {},
	updated() {},
	methods: {
		// Set page name
		setPage(url) {
			let page = 1
			page = url.split('?')[1].replace('page=', '')
			this.$emit('getItems', { page })
		},
		formatNumberLocale(value) {
			return formatNumberLocaleUtil(value)
		},
	},
	filters: {
		removeString: function(value) {
			if (!value) return ''
			value = value.replace('&laquo;', '')
			return value.replace('&raquo;', '')
		},
	},
}
</script>
